// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { documentsStyles } from "@west/Overrides/Widgets/ProductDetails/ProductDetailsDocuments";
import Document from "@west/XDL/Icons/Document";
import Minus from "@west/XDL/Icons/Minus";
import Plus from "@west/XDL/Icons/Plus";
import { mergeWithCss } from "@west/XDL/Utilities";
import { viewAllStyle } from "@west/XDL/Utilities/links";
import { css } from "styled-components";

documentsStyles.wrapper = {
    css: css``,
};

documentsStyles.container = {
    gap: 12,
    css: css`
        &.for-print {
            display: none;
            @media print {
                display: block;
            }
        }

        &:not(.for-print) {
            display: block;
            @media print {
                display: none;
            }
        }
    `,
};

documentsStyles.documentGridItem = {
    width: 12,
};

documentsStyles.documentsTitle = {
    variant: "h5",
    forwardAs: "p",
};

documentsStyles.documentIcon = {
    src: Document,
    size: 12,
    color: "text.link",
    css: css`
        margin-right: 8px;
        opacity: 0.66;
    `,
};

documentsStyles.documentNameText = {
    size: 12,
    lineHeight: "14px",
    weight: "bold",
    css: css`
        text-wrap: wrap;
        word-break: break-all;
    `,
};

documentsStyles.documentLink = {
    css: css``,
    typographyProps: {
        css: css`
            display: flex;
        `,
    },
};
documentsStyles.documentLinkMore = {
    ...mergeWithCss(viewAllStyle, {
        icon: {
            iconProps: {
                src: Plus,
                size: 12,
                css: css`
                    opacity: 0.66;
                `,
            },
        },
    }),
};
documentsStyles.documentLinkLess = {
    ...mergeWithCss(viewAllStyle, {
        icon: {
            iconProps: {
                src: Minus,
                size: 12,
                css: css`
                    opacity: 0.66;
                `,
            },
        },
    }),
};
